import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheAnalogManifesto() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-analog-manifesto" ref={sectionRef} className="dark bg-background text-foreground py-20 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          {}
          <div className={cn("relative w-full max-w-md mx-auto lg:max-w-none lg:mx-0 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12")}>
            <div className="relative p-4 border border-border/20 bg-card/5 shadow-2xl">
              <AspectRatio ratio={4 / 5}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556059/img/bw_portrait_shadows.png" alt="Black and white portrait with deep shadows and grain" className="w-full h-full object-cover grayscale contrast-125 brightness-90" />
                {}
                <div className="absolute inset-0 bg-black/10 pointer-events-none mix-blend-overlay" />
              </AspectRatio>
            </div>
          </div>

          {}
          <div className={cn("flex flex-col justify-center transition-all duration-1000 ease-out delay-300", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12")}>
            <div className="max-w-xl mx-auto pl-0 !text-[hsl(21,90%,48%)] lg:mx-0 lg:pl-8">
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight mb-8 text-primary tracking-tight">
                The Soul in the Silver
              </h2>

              <div className="space-y-8 text-lg md:text-xl leading-relaxed text-muted-foreground font-sans font-light tracking-wide">
                <p>In an era defined by the instantaneous, we find our sanctuary in the slow. To shoot film is to embrace the weight of a decision—the knowledge that each exposure is finite, physical, and irreversible. It is a practice of intentionality that digital sensors cannot replicate.&nbsp;</p>
                <p>
                  We do not seek the clinical perfection of pixels. We chase the alchemy 
                  of light and chemistry. The grain is not noise; it is the texture of 
                  time itself. The shadows are not empty; they are the deep breaths between 
                  the notes. This is our rebellion against the ephemeral—a commitment to 
                  crafting images that possess a heartbeat.
                </p>
              </div>

              <div className="mt-16 flex justify-end">
                <div className="text-right">
                  <span className="block font-serif italic text-2xl md:text-3xl text-foreground/80 rotate-[-2deg]">
                    Alex Carter
                  </span>
                  <span className="block text-xs uppercase tracking-widest text-muted-foreground mt-2">
                    Founder & Lead Photographer
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}